<template>
  <div>
    <div class="prompt_header">Quick prompts</div>
    <div class="prompt_quick">Add quick prompt</div>
    <div class="prompt_conent_input">
      <div class="prompt_content_desc">
        <div class="prompt_title">Title: <span>*</span></div>
        <InputWebsite class="prompt_input" :placeholder="placeholder" />
      </div>
      <div class="prompt_content_desc">
        <div class="prompt_title">Link: <span>*</span></div>
        <div class="prompt_input_flex">
          <InputWebsite
            class="prompt_input prompt_btn_input"
            :placeholder="link"
          />
          <div class="prompt_under">
            If this is set, then the prompt will be ignored and this link will
            be opened instead of sending the prompt in the chat.
          </div>
        </div>
      </div>
      <div class="prompt_content_desc">
        <div class="prompt_title">Prompt:</div>
        <textarea
          class="textarea"
          name="details"
          placeholder="How to contact your team?"
        >
        </textarea>
      </div>
      <ButtonWithLoadWebsite class="promp_btn" title="Add quick prompt" />
    </div>
  </div>
</template>

<script>
import InputWebsite from "../../components/shared/InputWebsite.vue";
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
export default {
  components: {
    InputWebsite,
    ButtonWithLoadWebsite,
  },
  data() {
    return {
      placeholder: "My company Chatbot",
      link: "www.yoursite.com",
      prompt: "How to contact your team?",
    };
  },
};
</script>
<style scoped>
.prompt_header {
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.prompt_quick {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  padding-top: 44px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.prompt_under {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.prompt_title {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.prompt_title span {
  color: #f00;
}
.prompt_conent_input {
  max-width: 358px;
  width: 100%;
  align-items: flex-start;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.prompt_content_desc {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
}
.prompt_input_flex {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.prompt_input_prompt {
  height: 90px !important;
}
.prompt_input_prompt::placeholder {
  top: 0;
  position: relative;
}
.promp_btn {
  padding: 11px 27px;
}
textarea[name="details"] {
  resize: none;
  max-width: 312px;
  height: 90px;
  width: 100%;
  padding: 12px 20px;
  border-radius: 6px;
}
.textarea {
  outline-color: #3056d3;
}
</style>
